import {
  ICreateUpdateFormField,
  ReadCardField,
} from '../../CommonInterfaces/Form';

export const EventSubjectReadFields: ReadCardField[] = [
  {
    title: 'Идентификатор',
    name: 'id',
  },
  {
    title: 'Название',
    name: 'name',
  },
];

export const EventSubjectUpdateFields: ICreateUpdateFormField[] = [
  {
    title: 'Название',
    name: 'name',
  },
];


